<template>
  <div class="wrap">
    <form class="sign-up-form">
      <table class="tableDetails">
        <tbody>
          <tr>
            <td>
              <span class="red-tips">*</span>姓名:
            </td>
            <td>
              <input
                :class="[
                                    'input-border',
                                    errorList[0] ? 'input-err' : ''
                                ]"
                @focus="hideErr(0)"
                type="text"
                name="name"
                maxlength="40"
                v-model="postData.name"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="red-tips">*</span>性别:
            </td>
            <td>
              <div class="label-box flex-row">
                <label class="radio-label flex-row" for="sign-in-man">
                  <input type="radio" name="sex" value="1" id="sign-in-man" v-model="postData.sex" />
                  <span>男</span>
                </label>
                <label class="radio-label flex-row" for="sign-in-woman">
                  <input
                    type="radio"
                    name="sex"
                    value="2"
                    id="sign-in-woman"
                    v-model="postData.sex"
                  />
                  <span>女</span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="red-tips">*</span>民族:
            </td>
            <td>
              <input
                :class="[
                                    'input-border',
                                    errorList[2] ? 'input-err' : ''
                                ]"
                @focus="hideErr(2)"
                name="nation"
                type="text"
                v-model="postData.nation"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="red-tips">*</span>政治面貌:
            </td>
            <td>
              <input
                :class="[
                                    'input-border',
                                    errorList[3] ? 'input-err' : ''
                                ]"
                @focus="hideErr(3)"
                name="politicalOutlook"
                type="text"
                v-model="postData.politicalOutlook"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="red-tips">*</span>身份证号:
            </td>
            <td>
              <input
                :class="[
                                    'input-border',
                                    errorList[4] ? 'input-err' : ''
                                ]"
                @focus="hideErr(4)"
                name="identificationCard"
                type="text"
                v-model="postData.identificationCard"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="red-tips">*</span>移动电话:
            </td>
            <td>
              <input
                :class="[
                                    'input-border',
                                    errorList[5] ? 'input-err' : ''
                                ]"
                @focus="hideErr(5)"
                name="phone"
                type="text"
                v-model="postData.phone"
              />
            </td>
          </tr>
          <tr>
            <td>原工作单位:</td>
            <td>
              <input class="input-border" name="workplace" type="text" v-model="postData.workplace" />
            </td>
          </tr>
          <tr>
            <td>现住址:</td>
            <td>
              <textarea name="homeAdress" maxlength="140" rows="4" v-model="postData.homeAdress"></textarea>
            </td>
          </tr>
          <tr>
            <td>电子邮箱:</td>
            <td>
              <input class="input-border" type="text" name="email" v-model="postData.email" />
            </td>
          </tr>
          <tr>
            <td>
              <span class="red-tips">*</span>亲属姓名:
            </td>
            <td>
              <input
                :class="[
                                    'input-border',
                                    errorList[9] ? 'input-err' : ''
                                ]"
                @focus="hideErr(9)"
                type="text"
                name="relativesName"
                v-model="postData.relativesName"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="red-tips">*</span>亲属电话:
            </td>
            <td>
              <input
                :class="[
                                    'input-border',
                                    errorList[10] ? 'input-err' : ''
                                ]"
                @focus="hideErr(10)"
                type="text"
                name="relativesPhone"
                v-model="postData.relativesPhone"
              />
            </td>
          </tr>
          <tr>
            <td>专业及特长:</td>
            <td>
              <textarea name="speciality" v-model="postData.speciality" rows="6"></textarea>
            </td>
          </tr>
          <tr>
            <td>既往病历及常用药物:</td>
            <td>
              <div class="label-box flex-row">
                <label class="radio-label flex-row" for="past-have">
                  <input
                    v-model="postData.pastMedicalHistory"
                    type="radio"
                    name="pastMedicalHistory"
                    value="1"
                    id="past-have"
                  />
                  <span>有</span>
                </label>
                <label class="radio-label flex-row" for="past-not">
                  <input
                    type="radio"
                    v-model="postData.pastMedicalHistory"
                    name="pastMedicalHistory"
                    value="2"
                    id="past-not"
                  />
                  <span>无</span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <textarea
                name="commonlyUsedDrugs"
                maxlength="500"
                v-model="postData.commonlyUsedDrugs"
                rows="6"
              ></textarea>
            </td>
          </tr>
          <!--                    <tr>
                        <td>对培训的意见或建议:</td>
                        <td>
                            <textarea
                                name="auditOpinion"
                                v-model="postData.auditOpinion"
                                maxlength="140"
                                rows="6"
                            ></textarea>
                        </td>
          </tr>-->
          <tr>
            <td>
              <span class="red-tips">*</span>上传照片:
            </td>
            <td>
              <label for="idcardpic">
                <div
                  :class="[
                                        'idcard-img-box',
                                        errorList[15] ? 'input-err' : ''
                                    ]"
                  @click="hideErr(15)"
                >
                  <img class="prev-idcard-img" :src="loadedImg" alt />
                  <div>
                    <span class="iconfont">&#xeb78;</span>
                    <p>上传身份证</p>
                  </div>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  style="display:none"
                  id="idcardpic"
                  name="pic"
                  @change="loadImg($event)"
                />
              </label>
              <p class="idcard-tips">请上传身份证正面</p>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <div @click="submitData" class="Btn">确认提交</div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div v-show="errData.tag" class="dilog-box animated">{{ errData.text }}</div>
  </div>
</template>

<script>
import { testPhone, testIDcard } from "@/common/util.js";
import { clearTimeout, setTimeout } from "timers";
export default {
    name: "signUp",
    data() {
        return {
            postData: {
                name: "",
                sex: "1",
                nation: "",
                politicalOutlook: "",
                identificationCard: "",
                phone: "",
                workplace: "",
                homeAdress: "",
                email: "",
                relativesName: "",
                relativesPhone: "",
                speciality: "",
                pic: "",
                pastMedicalHistory: "2",
                commonlyUsedDrugs: "",
                suggestion: ""
            },
            personData: {},
            loadedImg: "",
            enableSubmit: true,
            errorList: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            pendding: false,
            errData: {
                text: "",
                tag: false,
                timmer: null
            },
            show: false
        };
    },
    created() {
        console.log(this.$route.query.id);
        this.getPersonData()
        this.gain()
    },
    methods: {
         getPersonData() {
            this.$ajax({
                method: "post",
                url: "userApi/lookUser",
                data: {
                    token: this.$store.state.userToken
                },
                success: res => {
                    if (res.code == 200) {
                        this.postData = {
                            name: res.message.name, // 姓名
                            sex: res.message.sex == "M" ? "1" : "2", // 性别
                            email: res.message.email, // 邮件地址
                            phone: res.message.phone, // 手机号
                            avatar: res.message.avatar, // 
                            nickname: res.message.nickname,
                            identificationCard: res.message.idcard,
                            hobby: res.message.hobby, // 爱好
                            workplace:'',
                            homeAdress: res.message.address, //地址
                            nation: res.message.nationality, // 民族
                            politicalOutlook:'',  //政治面貌
                            speciality: '', // 专业和特长
                            pastMedicalHistory: '2', //既往病历及常用药物:
                            commonlyUsedDrugs: "",
                            suggestion: "",
                            relativesName: '', // 亲属姓名
                            relativesPhone: '', // 亲属电话
                            pic:'', // 图片
                        };
                        console.log(this.personData)
                        this.$store.commit("setAvatar", res.message.avatar);
                    }
                }
            });
        },
        showErrdata(index, text) {
            if (this.errData.timmer) {
                clearTimeout(this.errData.timmer);
                this.errData.timmer = null;
            }
            this.errData.text = text;
            this.enableSubmit = false;
            this.errData.tag = true;
            this.errData.timmer = setTimeout(() => {
                clearTimeout(this.errData.timmer);
                this.errData.timmer = null;
                this.errData.tag = false;
            }, 2000);
            this.errorList[index] = true;
            this.$forceUpdate();
        },
        showModel(text, callback) {
            if (this.errData.timmer) {
                clearTimeout(this.errData.timmer);
                this.errData.timmer = null;
            }
            this.errData.tag = true;
            this.errData.text = text;
            this.errData.timmer = setTimeout(() => {
                clearTimeout(this.errData.timmer);
                this.errData.timmer = null;
                this.errData.tag = false;
                callback && callback();
            }, 2000);
        },
        gain() {
            this.$ajax({
                method: "post",
                url: "wechatApi/getRegInformation",
                data: {
                    token: this.$store.state.userToken
                },
                success: res => {
                    let a = JSON.parse(res)
                    console.log(a.message)
                    if(a.message != null) {
                        this.show = true
                        this.arr = a.message
                        console.log(this.arr)
                        this.postData = this.arr
                        this.loadedImg = this.arr.image
                    }
                }
            });
        },
        hideErr(index) {
            this.errorList[index] = false;
            this.$forceUpdate();
        },
        submitData() {
            this.enableSubmit = true;
            if (this.pendding) {
                this.showModel("正在提交...");
                return;
            }
            if (!this.postData.pic) {
                this.showErrdata(15, "请上传身份证");
            }
            if (!testPhone(this.postData.relativesPhone)) {
                this.showErrdata(10, "亲属手机号错误");
            }
            if (this.postData.relativesName.length == 0) {
                this.showErrdata(9, "请输入亲属姓名");
            }
            if (!testPhone(this.postData.phone)) {
                this.showErrdata(5, "手机号错误");
            }
            // if (!testIDcard(this.postData.identificationCard)) {
            //     this.showErrdata(4, "身份证号错误");
            // }
            if (this.postData.politicalOutlook.length == 0) {
                this.showErrdata(3, "请输入政治面貌");
            }
            if (this.postData.nation.length == 0) {
                this.showErrdata(2, "请输入民族");
            }
            if (
                this.postData.name.length < 2 ||
                this.postData.name.length > 16
            ) {
                this.showErrdata(0, "姓名为2~16位字符");
            }

            if (this.enableSubmit) {
                var signData = new FormData(
                    document.querySelector(".sign-up-form")
                );
                signData.append("id", this.$route.query.id);
                signData.append("token", this.$store.state.userToken);
                this.$ajax({
                    url: "wechatApi/communityUniversityStudentSignUp",
                    data: signData,
                    cache: false,
                    processData: false,
                    contentType: false,
                    success: res => {
                        console.log(res);
                        if (res.code == 200) {
                            this.resetData();
                            this.showModel("报名成功", () => {
                                this.$router.back(-1);
                            });
                            this.pendding = false;
                        } else {
                            this.showModel(res.message);
                            this.pendding = false;
                        }
                    },
                    error: res => {
                        this.pendding = false;
                    }
                });
            }
        },
        resetData() {
            this.postData = {
                name: "",
                sex: "1",
                nation: "",
                politicalOutlook: "",
                identificationCard: "",
                phone: "",
                workplace: "",
                homeAdress: "",
                email: "",
                relativesName: "",
                relativesPhone: "",
                speciality: "",
                pic: "",
                pastMedicalHistory: "2",
                commonlyUsedDrugs: "",
                suggestion: ""
            };
            this.loadedImg = "";
        },
        loadImg(even) {
            if (even.target.files.length != 0) {
                var fileReader = new FileReader();

                fileReader.onload = res => {
                    this.loadedImg = res.target.result;
                };

                fileReader.readAsDataURL(even.target.files[0]);

                this.postData.pic = even.target.files[0];
    
            } else {
                this.postData.pic = "";
                this.loadedImg = "";
            }
        }
    }
};
</script>

<style scoped="scoped" lang="scss">
.wrap {
  width: 1000px;
  min-height: 500px;
  margin: 0 auto;
}

.tableDetails {
  width: 500px;
  margin: 0 auto;
  margin-top: 50px;
  td {
    padding: 5px;
    vertical-align: top;
  }
  td:nth-child(1) {
    text-align: right;
  }
  td:nth-child(2) {
    text-align: left;
  }
}

.tableDetails .input-border {
  border: 1px solid #bbb;
  height: 30px;
  width: 300px;
}

textarea {
  width: 300px;
  border: 1px solid #bbb;
}
.Btn {
  text-align: center;
  width: 200px;
  padding: 5px 0;
  color: white;
  background-color: #6ac0e8;
  margin-top: 10px;
  border-radius: 4px;
  cursor: pointer;
  transition: all ease 0.2s;
}
.Btn:hover {
  color: #000;
}
#man,
#woman,
#have,
#none {
  width: 20px;
}
.red-tips {
  color: red;
  padding-right: 5px;
}

.label-box {
  .radio-label {
    width: 70px;
    align-items: center;
  }
}
.idcard-img-box {
  width: 200px;
  height: 100px;
  border: 1px solid #aaa;
  position: relative;
  .prev-idcard-img {
    width: 200px;
    height: 100px;
    position: absolute;
    top: 0;
    left: 0;
  }
  div {
    width: 200px;
    height: 100px;
    position: relative;
    z-index: 2;
    overflow: hidden;
    transition: all ease 0.2s;
    span {
      font-size: 30px;
      display: block;
      height: 30px;
      width: 30px;
      line-height: 30px;
      margin: 20px auto 10px;
    }
    p {
      line-height: 30px;
      text-align: center;
      font-size: 14px;
    }
  }
  div:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.idcard-tips {
  width: 200px;
  text-align: center;
  font-size: 16px;
  color: #666;
}
.tableDetails .input-err {
  border: 1px solid red !important;
}
.dilog-box {
  width: 300px;
  height: 50px;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 300px;
  left: 50%;
  margin-left: -150px;
  border-radius: 25px;
  color: #fff;
  text-align: center;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/lnjy/signUp.vue